
export const BASE = process.env.REACT_APP_SERVER_URL;
// export const BASE = 'symbian.stvffmn.com:20010';
export const BASE_HTTP = `https://${BASE}`;
export const BASE_URL = `${BASE_HTTP}/api`;

export const BASE_CLIENT_URL = `https://${BASE}/api/client`;
// export const BASE_URL = 'http://symbian.stvffmn.com:20004/api';

export const UPDATE_USER_PASSWORD = `${BASE_CLIENT_URL}/password`
export const OTHER_UPDATE_USER_PASSWORD = `${BASE_CLIENT_URL}/account/update/password`
export const UPDATE_USER_INFOS = `${BASE_CLIENT_URL}/account/update/infos`
export const CONFIRM_EMAIL = `${BASE_CLIENT_URL}/email/confirm`
export const RESEND_EMAIL = `${BASE_CLIENT_URL}/email/resend`
export const UNAUTHENTICATED_CONFIRM_EMAIL = `${BASE_CLIENT_URL}/email/unauthenticated/confirm`

export const UPLOAD_FILE = `${BASE_URL}/file/upload`

export const GET_FICHES_TYPE = `${BASE_URL}/fiches-types`
export const GET_CAUSES = `${BASE_URL}/causes`

export const DOWNLOAD_FICHE_RESUME = `${BASE_CLIENT_URL}/fiche/download/resume`

export const LOAD_DETAILS = `${BASE_CLIENT_URL}/fiche/details`
export const LOAD_STATE_HISTORIES = `${BASE_CLIENT_URL}/fiche/state-histories`

export const DO_FICHE_COMMANDE = `${BASE_CLIENT_URL}/fiche/to/commande`

export const DOWNLOAD_DOCUMENT = `${BASE_HTTP}/document`
export const DOWNLOAD_FICHE_DEVIS = `${BASE_HTTP}/devis/latest`
export const DOWNLOAD_DEVIS_MO = `${BASE_HTTP}/devis/mo`
export const LOAD_FICHE_DEVIS = `${BASE_CLIENT_URL}/fiche/devis`
export const DOWNLOAD_SPECIFIC_DEVIS = `${BASE_HTTP}/devis`

export const TEST_FICHE_DEVIS = `${BASE_HTTP}/fiche/to/devis-accepted-test`

export const CONFIRMING_WORK_EXECUTION = `${BASE_CLIENT_URL}/fiche/to/work-confirmed`
export const DENIEDING_WORK_EXECUTION = `${BASE_CLIENT_URL}/fiche/to/work-denied`


export const DENIED_FICHE_DEVIS = `${BASE_CLIENT_URL}/fiche/to/devis-denied`
export const VALIDATE_FICHE_DEVIS = `${BASE_CLIENT_URL}/fiche/to/devis-accepted`

export const SEARCH_FICHE_BY_FORM_CODE = `${BASE_URL}/fiches/find/by-code`;
export const VALIDATE_USER_EMAIL = `${BASE_URL}/fiche/validate/email`;

export const STORE_FICHE = `${BASE_CLIENT_URL}/fiche`
export const UPDATE_FICHE = `${BASE_URL}/fiche/update`
export const DELETE_FICHE = `${BASE_CLIENT_URL}/fiche`
export const CONFIRM_FICHE = `${BASE_CLIENT_URL}/fiche/confirm`
export const FIND_FICHE_BY_CODE = `${BASE_URL}/fiche/find`
export const FIND_FICHE_BY_FETCH_CODE = `${BASE_URL}/fiche/details/by/fetch-code`
export const GET_FETCH_CODE = `${BASE_URL}/fiches/get/fetch-code`
export const FIND_FICHE_BY_FORM_CODE = `${BASE_URL}/fiche/details/by/form-code`

export const SEARCH_FICHES = `${BASE_CLIENT_URL}/fiches`
export const FICHE_STATE_TO_PRISE_EN_COMPTE = `${BASE_URL}/fiche/to/prise-en-compte`
export const FICHE_STATE_TO_TERMINER = `${BASE_URL}/fiche/to/terminer`
export const FICHE_STATE_TO_CANCELED = `${BASE_URL}/fiche/to/annuler`


export const FICHE_SEND_DOCUMENTS = `${BASE_CLIENT_URL}/fiche/send-document`
export const LOAD_SENDED_DOCUMENTS = `${BASE_CLIENT_URL}/fiche/documents`
export const LOAD_FICHE_COMMENTS = `${BASE_CLIENT_URL}/fiche/comments`
export const LOAD_FICHE_HISTORY = `${BASE_CLIENT_URL}/fiche/histories`


export const UPDATE_DONNEE_GEOGRAPHIQUE = `${BASE_URL}/configurations/donnees/geographique`
export const BASE_DONNEE_TECHNIQUE = `${BASE_URL}/configurations/donnees/technique`

export const GET_VILLES = `${BASE_URL}/villes`;
export const GET_COMMUNES = `${BASE_URL}/communes`;
export const GET_QUARTIERS = `${BASE_URL}/quartiers`;
export const GET_RUES = `${BASE_URL}/rues`;

export const GET_ROLES = `${BASE_URL}/roles`

export const SEARCH_ABONNEMENTS = `${BASE_URL}/abonnements`
export const EXPORT_EXCELL = `${BASE_CLIENT_URL}/fiche/export/excel`
export const EXPORT_PDF = `${BASE_URL}/fiche/export/pdf`

export const STORE_USER = `${BASE_URL}/user`
export const USER_LIST = `${BASE_URL}/users`
export const DELETE_USER = `${BASE_URL}/user`

export const STEP_SAVE_DESCRIPTION = `${BASE_CLIENT_URL}/fiche/step/description`;
export const STEP_SAVE_LOCALISATION = `${BASE_CLIENT_URL}/fiche/step/localisation`;
export const STEP_SAVE_CONTACT = `${BASE_CLIENT_URL}/fiche/step/contact`;
export const STEP_SAVE_PERIOD = `${BASE_CLIENT_URL}/fiche/step/period`;


export const PAGE_VIEWED = `${BASE_URL}/page-viewed`

export const SIGNIN_WITH_GOOGLE = `${BASE_CLIENT_URL}/auth/google-signin`
